import React from 'react';
import { t } from 'i18next';

import LabeledInput from './LabeledInput';

function Password({ labelText, validators, placeHolder, innerRef, ...restOfProps }) {
    let passwordValidators = [
        {
            rgx: /.{8,}/,
            failText: t('Authentication.CreateAccount.EnterPasswordLength'),
        },
        {
            rgx: /\d/,
            failText: t('Authentication.CreateAccount.EnterPasswordNumber'),
        },
        {
            rgx: /[$!@#%^&*]/,
            failText: t('Authentication.CreateAccount.EnterPasswordSymbol'),
        },
        {
            rgx: /[A-Z]/,
            failText: t('Authentication.CreateAccount.EnterUppercase'),
        },
        {
            rgx: /[a-z]/,
            failText: t('Authentication.CreateAccount.EnterLowercase'),
        },
    ];

    if (validators) {
        let defaultValidators = passwordValidators.values();
        for (let v1 of defaultValidators) {
            let newValidators = validators.values();
            for (let v2 of newValidators) {
                if (v1.rgx.toString() === v2.rgx.toString()) {
                    v1.failText = v2.failText;
                }
            }
        }
        passwordValidators.concat(validators);
        passwordValidators = [...new Set(passwordValidators)];
    }

    return (
        <LabeledInput
            masked={true}
            validators={passwordValidators}
            labelText={labelText ? labelText : t('Password.PasswordLabel')}
            placeholder={placeHolder ? placeHolder : t('Password.EnterPassword')}
            ref={innerRef}
            {...restOfProps}
        />
    );
}

Password.displayName = 'Password';

export default Password;
